'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactRouter = require('react-router');

var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _AgencyInfoWindow = require('./AgencyInfoWindow.scss');var styles = _interopRequireWildcard(_AgencyInfoWindow);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
// Styles
var AgencyInfoWindow = function (_Component) {_inherits(AgencyInfoWindow, _Component);function AgencyInfoWindow() {var _temp, _this, _ret;_classCallCheck(this, AgencyInfoWindow);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.







    clickHandler = function (evt) {
      evt.stopPropagation();
      _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/company/' + _this.props.agencyId));
    }, _temp), _possibleConstructorReturn(_this, _ret);}AgencyInfoWindow.prototype.componentDidMount = function componentDidMount() {this.infoWindow && this.infoWindow.addEventListener('click', this.clickHandler);};AgencyInfoWindow.prototype.componentWillUnmount = function componentWillUnmount() {this.infoWindow && this.infoWindow.removeEventListener('click', this.clickHandler);};AgencyInfoWindow.prototype.

  render = function render() {var _this2 = this,_cx,_cx2;
    return (
      _react2.default.createElement('div', {
          className: styles.agencyInfoWindow,
          ref: function ref(_ref) {_this2.infoWindow = _ref;} },

        _react2.default.createElement('div', {
          className: styles.agencyLogo,
          style: {
            backgroundImage: 'url(' + this.props.image + ')' } }),


        _react2.default.createElement('div', { className: styles.agencyContent },
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.agencyTitle, (_cx = {}, _cx[styles.defaultLang] = this.props.titleAtDefaultLang, _cx)) },
            this.props.title),

          _react2.default.createElement('div', { className: styles.agencyInfo },
            _react2.default.createElement('div', { className: (0, _classnames2.default)((_cx2 = {}, _cx2[styles.defaultLang] = this.props.titleAtDefaultLang, _cx2)) },
              _react2.default.createElement('span', { className: 'icon icon-office' }),
              this.props.name),

            _react2.default.createElement('div', null,
              _react2.default.createElement('span', { className: 'icon icon-pin' }),
              this.props.address))),



        this.props.doesAgencyPageExist &&
        _react2.default.createElement('a', { className: styles.pageLink },
          this.props.pageLinkTitle)));




  };return AgencyInfoWindow;}(_react.Component);


AgencyInfoWindow.propTypes = {
  locale: _propTypes2.default.string,
  name: _propTypes2.default.string,
  title: _propTypes2.default.string,
  nameAtDefaultLang: _propTypes2.default.bool,
  titleAtDefaultLang: _propTypes2.default.bool,
  address: _propTypes2.default.string,
  image: _propTypes2.default.string,
  pageLinkTitle: _propTypes2.default.string,
  doesAgencyPageExist: _propTypes2.default.bool,
  agencyId: _propTypes2.default.string };exports.default =


AgencyInfoWindow;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AgencyInfoWindow/AgencyInfoWindow.js
// module id = 2574
// module chunks = 0